import { Component, Input, OnInit } from '@angular/core';
import { TipoEntregas } from '../shared/Util';
import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { PopupDetalhesPedidoService } from '../popup-detalhes-pedido/popup-detalhes-pedido.service';
import { NgIf, NgFor, DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PopupDetalhesPedidoComponent } from '../popup-detalhes-pedido/popup-detalhes-pedido.component';

@Component({
    selector: 'app-detalhe-entrega-coleta',
    templateUrl: './detalhe-entrega-coleta.component.html',
    styleUrls: ['./detalhe-entrega-coleta.component.css'],
    standalone: true,
    imports: [NgIf, NgbTooltip, NgFor, PopupDetalhesPedidoComponent, DecimalPipe, CurrencyPipe, DatePipe]
})
export class DetalheEntregaColetaComponent {
  @Input() item;
  dadosEntregas : any;
  dadosColetas: any;
  versaoApp: string;;
  contadorPedEntregues: number;
  contadorPedPendentes: number;
  contadorPedRecusados: number;
  contadorColEntregues: number;
  contadorColRecusados: number;
  contadorColPendentes: number

 




  constructor(private boxListTruckService: BoxListTruckService, 
    public detalhesPedidosServices: PopupDetalhesPedidoService,
    
  ){} 


  ngOnInit(){
    this.getPedidosEntregues();
    this.getPedidosRecusados();
    this.getPedidosPendentes();
    this.getColetasEntregues();
    this.getColetasRecusados();
    this.getColetasPendentes();
  }   

  ngOnChanges(): void {

    this.versaoApp = this.boxListTruckService.listTruckService.VersaoApp;

    this.dadosEntregas = {
      entregas: this.item.pedidos.filter(pedido => pedido.Tipo == TipoEntregas.Entrega || pedido.Tipo == TipoEntregas.XmlEntrega),
      valorTotalPedido: 0,
      pesoTotalPedido: 0,
      QtdeVolumes: 0,
      custoDescarga: 0
    };   

    this.dadosEntregas.valorTotalPedido = this.dadosEntregas.entregas.reduce((total, pedido) => total + pedido.ValorPedido, 0);
    this.dadosEntregas.pesoTotalPedido = this.dadosEntregas.entregas.reduce((total, pedido) => total + pedido.Peso, 0);
    this.dadosEntregas.QtdeVolumes = this.dadosEntregas.entregas.reduce((total, pedido) => total + pedido.QtdeVolumes, 0);
    this.dadosEntregas.custoDescarga = this.dadosEntregas.entregas.reduce((total, pedido) => total + pedido.custoDescarga, 0);
    this.dadosEntregas. custoDescarga = this.item.custoDescarga;

 
    this.dadosColetas = {
      coletas: this.item.pedidos.filter(pedido => pedido.Tipo == TipoEntregas.Coleta),
      valorTotalPedido: 0,
      pesoTotalPedido: 0,
      QtdeVolumes: 0
    };
    
    this.dadosColetas.valorTotalPedido = this.dadosColetas.coletas.reduce((total, pedido) => total + pedido.ValorPedido, 0);
    this.dadosColetas.pesoTotalPedido = this.dadosColetas.coletas.reduce((total, pedido) => total + pedido.Peso, 0);
    this.dadosColetas.QtdeVolumes = this.dadosColetas.coletas.reduce((total, pedido) => total + pedido.QtdeVolumes, 0);
    


  }


  atualizaDetalhesPedido(pedido){
    this.detalhesPedidosServices.chaveAcesso = pedido.chaveAcesso;
    this.detalhesPedidosServices.motivoColeta = null;

    if(pedido.Tipo == TipoEntregas.Coleta){
      const jsonDetalhePedido = JSON.parse(pedido.detalhePedido)
      const detalhePedido = [];
      this.detalhesPedidosServices.motivoColeta = jsonDetalhePedido.descricaoColeta
      jsonDetalhePedido.produtos.forEach(element => {
        const produto = {
          cdProd: element.cdProd,
          descricaoProduto: element.descricao,
          quantidade: element.qtde,
        }
        detalhePedido.push(produto);
      });
      this.detalhesPedidosServices.atualizaDetalhesPedidos(detalhePedido)
    }else{
      this.detalhesPedidosServices.atualizaDetalhesPedidos(pedido.detalhePedido)
    }
    this.detalhesPedidosServices.mostrarPopDetalhesPedido = true;
  }

  getPedidosEntregues() {
    this.contadorPedEntregues = this.dadosEntregas.entregas.filter(itemPedido => itemPedido.IdRoteiroPedidoSituacao == 6 || itemPedido.EntregaRealizada == 1).length;
  }

  getPedidosRecusados() {
    this.contadorPedRecusados = this.dadosEntregas.entregas.filter(item => item.IdRoteiroPedidoSituacao === 5 || item.EntregaRealizada === 0).length;
  }

  getPedidosPendentes() {
    this.contadorPedPendentes = this.dadosEntregas.entregas.filter(item => item.IdRoteiroPedidoSituacao === 1 || item.IdRoteiroPedidoSituacao === 4 || item.IdRoteiroPedidoSituacao === 7).length;
  }

  getColetasEntregues() {
    this.contadorColEntregues = this.dadosColetas.coletas.filter(item => item.IdRoteiroPedidoSituacao == 6 || item.EntregaRealizada == 1).length;
  }

  getColetasRecusados() {
    this.contadorColRecusados = this.dadosColetas.coletas.filter(item => item.IdRoteiroPedidoSituacao === 5 || item.EntregaRealizada === 0).length;
  }

  getColetasPendentes() {
    this.contadorColPendentes = this.dadosColetas.coletas.filter(item => item.IdRoteiroPedidoSituacao === 1 || item.IdRoteiroPedidoSituacao === 4 || item.IdRoteiroPedidoSituacao === 7).length;
  }

  AbrirTabelaPedidos(e) {
    const target = $(e.currentTarget);
    const icon = target.find('.fa');
  
    if (target.hasClass('open')) {
      target.removeClass('open');
      target.parent().find('.pedidos-detalhes').slideUp(200);
      icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    } else {
      target.addClass('open');
      target.parent().find('.pedidos-detalhes').slideDown(200);
      icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
    }
  }
  

}
